import HorizontalMenu from './HorizontalMenu';

const initHorizontalMenu = () => {
  const menus = document.querySelectorAll('[data-horizontal-menu]');

  menus.forEach(item => {
    new HorizontalMenu(item);
  });
};

export default initHorizontalMenu;
